import {
  ReactFramework,
  TemplateStack,
  DesignSystem,
} from "@/utils/templateProjects";
import { UploadedFile } from "@/utils/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface ProjectCreateStore {
  hasHydrated: boolean;
  setHasHydrated: (state) => void;

  generateText: string;
  generateAttachedFiles: UploadedFile[] | null;
  setGenerateText: (text: string) => void;
  setGenerateAttachedFiles: (files: UploadedFile[] | null) => void;

  resetProjectCreateFlow: () => void;

  autoTriggerGenerate: boolean;
  setAutoTriggerGenerate: (state: boolean) => void;

  // Project type
  reactFramework: ReactFramework;
  setReactFramework: (framework: ReactFramework) => void;

  selectedTemplateStack: TemplateStack;
  setSelectedTemplateStack: (stack: TemplateStack | null) => void;

  selectedDesignSystem: DesignSystem | null;
  setSelectedDesignSystem: (designSystem: DesignSystem | null) => void;
}

export const useProjectCreateStore = create<ProjectCreateStore>()(
  persist(
    (set) => ({
      hasHydrated: false,
      setHasHydrated: (state) => set({ hasHydrated: state }),

      generateText: "",
      generateAttachedFiles: null,
      setGenerateText: (text: string) => set({ generateText: text }),
      setGenerateAttachedFiles: (files: UploadedFile[] | null) =>
        set({ generateAttachedFiles: files }),

      resetProjectCreateFlow: () => {
        set({
          generateText: "",
          generateAttachedFiles: null,
          reactFramework: ReactFramework.VITE,
          autoTriggerGenerate: false,
          selectedTemplateStack: TemplateStack.BLANK,
          selectedDesignSystem: DesignSystem.BLANK,
        });
      },

      autoTriggerGenerate: false,
      setAutoTriggerGenerate: (state: boolean) =>
        set({ autoTriggerGenerate: state }),

      reactFramework: ReactFramework.VITE,
      setReactFramework: (framework: ReactFramework) =>
        set({ reactFramework: framework }),

      selectedTemplateStack: TemplateStack.BLANK,
      setSelectedTemplateStack: (stack: TemplateStack) =>
        set({ selectedTemplateStack: stack }),

      selectedDesignSystem: DesignSystem.BLANK,
      setSelectedDesignSystem: (designSystem: DesignSystem) =>
        set({ selectedDesignSystem: designSystem }),
    }),
    {
      name: "project-create-store",
      onRehydrateStorage: (state) => {
        return () => state.setHasHydrated(true);
      },
    }
  )
);
